import UserModel from '../../models/user/UserModel.js';
import TrialSignupFormTemplate from '../../../templates/login/TrialSignupFormTemplate.html';

/*
 * trial signup Form View
 * #signup
 * JS
 */

const TrialSignupFormView = Backbone.View.extend({
  className: 'container',
  templateDefault: _.template(TrialSignupFormTemplate),

  events: {
    'click .btn-primary': 'handleCreateFreeTrial',
  },

  initialize() {
    const that = this;
    // render form

    this.$el.html(this.templateDefault({
      disableCaptcha: window.isAutomationEnvironmentCheck(),
    }));

    $('body').html(this.$el);

    // this setTimeout fixes bug
    // #411 The login page has broken layout for several seconds
    setTimeout(() => {
      that.$('.content').fadeIn();
      that.$('.login-avatar img').attr('src', window.appConfig.branding.logo_url);
    }, 1000);

    // setup scoped element variables
    this.$form = this.$el.find('#trialSignupForm');

    $.validator.addMethod('telephone', (value) => value === '' || (/^\d{7,}$/).test(value.replace(/[\s()+\-.]|ext/gi, '')), window.lookup('Please enter a valid telephone number.'));

    $.validator.addMethod('email', (value) => value === '' || value.match(window.globalObject.emailRegex), window.lookup('Please enter a valid email.'));

    $.validator.addMethod('username', (value) => /^[a-zA-Z0-9]+$/.test(value), window.lookup('Please enter only text or numbers.'));

    this.validationParameters = {
      submitHandler() {},
      onsubmit: true,
      showErrors: Utils.showErrors,
      unhighlight(element) {
        $(element).removeClass('error').parents('.control-group').removeClass('error');
      },
      rules: {
        'trial-email': {
          email: true,
          remote(evt) {
            const val = $(evt).val();

            return `${api_url}/api/utils/validate_user_fields?format=text&field_name=email&field_value=${encodeURIComponent(val)}`;
          },
          required: true,
        },
        'trial-telephone': 'telephone',
        'trial-username': {
          remote(evt) {
            const val = $(evt).val();

            return `${api_url}/api/utils/validate_user_fields?format=text&field_name=username&field_value=${encodeURIComponent(val)}`;
          },
          username: true,
          required: true,
        },
        'trial-password': {
          minlength: 5,
        },
        'trial-conf-password': {
          minlength: 4,
          equalTo: '#trial-password',
        },
        hiddenRecaptcha: {
          required() {
            if (window.isAutomationEnvironmentCheck()) {
              return false;
            }

            return grecaptcha.getResponse() == '';
          },
        },
      },
      messages: {
        hiddenRecaptcha: window.lookup('Please click on the checkbox'),
        'trial-conf-password': window.lookup('Please ensure the password matches'),
      },
    };

    this.$form.validate(this.validationParameters);
  },

  render() {
    return this;
  },

  handleCreateFreeTrial() {
    let userModel;
    let errorMessage;
    let isAutoHideErrorNotification;
    const that = this;

    if (this.$('#trialSignupForm').valid()) {
      // create user
      userModel = new UserModel();

      userModel.save({
        wl_apikey: window.appConfig.signup_key,
        password: this.$('#trial-password').val(),
        login: this.$('#trial-username').val(),
        email: this.$('#trial-email').val(),
        fullname: `${this.$('#trial-firstname').val()} ${this.$('#trial-lastname').val()}`,
        phonenumber: this.$('#trial-telephone').val(),
        timezone: 0,
        recaptcha: window.isAutomationEnvironmentCheck() ? '' : grecaptcha.getResponse(),
      }, {
        createTrialUser: true,
        success() {
          if (!window.isAutomationEnvironmentCheck()) {
            grecaptcha.reset();
          }

          that.$form.find('.btn-primary').button('loading');

          Sendible.Connect.loginMethod(
            window.appConfig.applicationId,
            {
              username: userModel.get('email'),
              api_key: userModel.get('api_key'),
              source: 'no_redirect',
            },
            _.bind(that.handleAPISuccess, that),
            _.bind(that.handleAPIError, that),
          );
        },
        error(model, response) {
          if (!window.isAutomationEnvironmentCheck()) {
            grecaptcha.reset();
          }

          errorMessage = window.lookup('We were unable to create a trial account. Please try again later.');
          isAutoHideErrorNotification = true;

          if (
            response
                        && response.error
                        && response.error.type
                        && response.error.type === 'exceed_trial_user_allowance'
                        && response.error.message
          ) {
            errorMessage = response.error.message;
            isAutoHideErrorNotification = false;
          }

          // TODO : Give feedback to the user if an error occurs
          Utils.notify(
            errorMessage,
            'error',
            null,
            isAutoHideErrorNotification,
          );
        },
      });
    }
  },

  handleAPISuccess(result) {
    if (typeof result.error !== 'undefined') {
      this.handleAPIError(result.error);
      return;
    }

    sessionStorage.setItem(window.appConfig.LOGIN_AUTH_TOKEN, result.access_token);

    this.options.parent.navigate('login', { trigger: true, replace: true });

    window.location.reload();
  },

  handleAPIError(result) {
    if (typeof result.error !== 'undefined') {
      this.handleErrors(result.error);
    }
  },

  cleanup() {
    this.unbind();
    this.remove();
  },

});

export default TrialSignupFormView;
